import { BookingAttachmentFile } from "./booking-attachment-file";

export class GmailMessageWithBookingFiles {

    constructor(
        public sendTo: string[],
        public subject: string,
        public body: string,
        public attachmentFiles: BookingAttachmentFile[],
        public signatureLanguageId: number | null,
        public bookingId: number,
        public withVivawalletPaymentLink: boolean,
        public backgroundColor: string | null
    ){}
}
